import LinkTo from '@di-shared/features/navigate/LinkTo';
import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {MainTripDetail} from '@di-shared/api/di/__generated';
import {parseDateWithFormat} from '@shared/dateUtils';
import {ERROR} from '@di-shared/const';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';

export interface SafeDrivingMainTripItemKrProps {
  tripItem: MainTripDetail;
  vin: string;
}

function SafeDrivingMainTripItemKr({tripItem}: SafeDrivingMainTripItemKrProps) {
  const {t} = useInferableTranslation();
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();
  const parseDate = parseDateWithFormat(tripItem.date);

  return (
    <li
      className="major_driving_item"
      key={tripItem.id}
    >
      <LinkTo
        // FIXME: 주행기록 배포되기 전 임시 수정
        // to={ROUTE_PATHS.HISTORY_$DATE_DRIVING_$IGN_TIME.getFullPath(vin, tripItem.date, tripItem.id)}
        to={'#'}
        className="major_driving_link"
      >
        <strong className="major_driving_rank">
          <span className="rank_text">{t('T20017_$n', {n: tripItem.ranking})}</span>
          <span className="count_text">
            <span className="count_value">{tripItem.qvsIncCnt + tripItem.qvsDecCnt + tripItem.qvsStartCnt}</span>
            <span className="count_unit">{t('T20133')}</span>
          </span>
        </strong>
        <div className="major_driving_info">
          <div className="major_driving_action">
            <span className="driving_action">
              <span className="action_text">{t('T10011')}</span>
              <span className="action_value">{tripItem.qvsIncCnt}</span>
            </span>
            <span className="divider divider_vertical"></span>
            <span className="driving_action">
              <span className="action_text">{t('T10012')}</span>
              <span className="action_value">{tripItem.qvsDecCnt}</span>
            </span>
            <span className="divider divider_vertical"></span>
            <span className="driving_action">
              <span className="action_text">{t('T10013')}</span>
              <span className="action_value">{tripItem.qvsStartCnt}</span>
            </span>
            <span className="ic ic_arrow_forward_12px"></span>
          </div>
          <div className="major_driving_detail">
            <span className="driving_date">{parseDate ? CldrDatetimeFormatter.format(parseDate, 'short') : ERROR.DASH}</span>
            <span className="divider divider_vertical"></span>
            <span className="driving_place">{tripItem.endLocation}</span>
          </div>
        </div>
      </LinkTo>
    </li>
  );
}

export default SafeDrivingMainTripItemKr;
